import apiCall from './apiCall';

export const listShippingZones = async () => {
  const resp = await apiCall('GET', '/shipping-zones', {}, {});

  return resp.data._embedded["shipping-zones"];
}
